<div class="onboarding-form">
  <h1>
    @for (titleLine of title; track titleLine) {
      {{ titleLine }} <br />
    }
  </h1>
  <p class="small text-muted fw-semibold mb-4">{{ subtitle }}</p>
  <div class="h4 mb-4">
    Enter the code we've sent <br />
    @if (phone()) {
      <span>to {{ phone() }}</span>
    }
  </div>
  <ng-otp-input
    id="otpField"
    (onInputChange)="onOtpChange($event)"
    [config]="otpConfig"></ng-otp-input>
  @if (error) {
    <p class="text-danger small mt-3">
      {{ error }}
    </p>
  }
  @if (resend$) {
    <div class="mt-4">
      <app-resend-btn
        [btnID]="formLabel() + 'ResendBtn'"
        btnClass="btn btn-light-on-white text-secondary"
        label="Resend code"
        [resend$]="resend$"></app-resend-btn>
    </div>
  }
  <br />
  <button
    [id]="formLabel() + 'SubmitBtn'"
    class="btn btn-primary btn-lg mt-4"
    (click)="verifyPhone()"
    [disabled]="btnDisabled">
    Verify code <i class="iconoir-arrow-right ms-2"></i>
  </button>
</div>

<app-profile-dropdown [signUpFlow]="true"></app-profile-dropdown>
